import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  guardar(idCuadernoProfesor, tipoCuaderno, preferencias, options) {
    const json = {
      cuaderno_profesor_id: idCuadernoProfesor,
      tipo_cuaderno: tipoCuaderno,
      preferencias,
    };
    return cifraClient.post('/api_publica/v1/cuadernos/configuracion/preferencias', json, options);
  },
};
